import { render, staticRenderFns } from "./addVideoManagement.vue?vue&type=template&id=971ef042&"
import script from "./addVideoManagement.vue?vue&type=script&lang=js&"
export * from "./addVideoManagement.vue?vue&type=script&lang=js&"
import style0 from "./addVideoManagement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports